<template>
  <div class="customer ma-3">

  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Πληρωμές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>


    <v-data-table
      :headers="headers"
      :items="debits"
      :search="search"
      loading: false
      sort-by="Date"
      sort-desc
      item-key="DocNumber"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showdialog(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
         <v-btn
          icon
          @click.stop="print(item, true)"
        >
         <v-icon>mdi-content-save</v-icon>
        </v-btn>
         <v-btn
          icon
          @click.stop="print(item, false)"
        >
         <v-icon>mdi-printer</v-icon>
        </v-btn>
         <v-btn
          icon
          @click.stop="send(item)"
        >
         <v-icon>mdi-send</v-icon>
        </v-btn>
     </template>

    <template v-slot:item.TotalValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.TotalValue) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}
      </td>
    </template>



    </v-data-table>
  </v-card>
</template>


  </div>
</template>

<script>

export default {
  data() {
    return {
      balance: {charges: 0, payments: 0},
      expanded: [],
      loading: true,
      search: '',
      customer: {},
      customer_id: this.$route.params.id,
      debits: [],
      headers: [
          {
            text: 'Αρ. Πληρωμής',
            align: 'start',
            //sortable: false,
            value: 'DocNumber',
            width: '10%',
          },
          { text: 'Ημερομηνία', value: 'Date', width: '10%' },
          { text: 'Συνολο', value: 'TotalValue', align: 'end' },
          { text: 'Τύπος', value: 'PaymTerm.Desc', align: 'center' },
          { text: 'Remarks', value: 'Remarks', align: 'center' },
          { text: 'Actions', value: 'actions', align: 'end' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/customers/'+this.customer_id);
        //console.log(response);
        this.customer = response.data;
        this.debits = this.customer.Debits;
        this.debits.push(...this.customer.TabDebits);
        //this.tabdebits = this.customer.TabDebits;
        this.balance = this.customer.Balance;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
   async print(item, pdf) {
        const options = {
          method: 'GET',
          url: '/customers/debits/print/'+item.Id,
          responseType: "blob",
        };


          this.$api(options).then((response) => {
          let url = window['URL'].createObjectURL(response.data)

          let iframe =  document.createElement('iframe'); //load content in an iframe to print later
          document.body.appendChild(iframe);
          if (pdf) {

          var a = document.createElement('a')
          a.href = url
          a.download = "receipt.pdf";
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)


          } else {

          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function() {
            setTimeout(function() {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          }

            }
        })
        .then(() => {
          // alert('File saved succesfully');
        })
        .catch((error) => {
          console.log(error);
        });

    },
    async send(item) {
        const options = {
          method: 'GET',
          url: '/customers/debits/send/'+item.Id,
          params: { "pdf": true}
        };


          this.$api(options).then((response) => {
            if (response.status == 200) {
                alert('Η απόδειξη εστάλη επιτυχώς.');
          } else {
            alert('Η αποστολή απέτυχε ', response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
  close () {
        this.timdialog = false
  }

  }
}
</script>
